var moduleName = "services.transaction";

let $inject = [
  "$http",
];

class TransactionService {
  /**
   * @param $http
   */
  constructor(
    $http
  ) {
    this.$http = $http;
  }

  /**
   * Get the relevant transactions
   * @param {Number} countPerPage
   * @param {Number} pageIndex Page number (from 0)
   * @param {Function} handleSuccess
   * @param {Function} handleError
   *
   * @returns {Promise}
   */
  cget(countPerPage, pageIndex, handleSuccess, handleError) {
    return this.$http.get(`/app/transactions/${countPerPage}/${pageIndex}`).then(handleSuccess, handleError);
  }
}

TransactionService.$inject = $inject;

export default angular.module(moduleName, [])
  .service("TransactionService", TransactionService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/transaction.service.js
 **/